import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon, SparklesIcon } from 'lucide-react';
type StackItem = {
  name: string;
  value: string;
};
export function ValueStackSummary() {
  const mainProductItems: StackItem[] = [{
    name: 'Protocolo Principal Silencio TTPM™',
    value: '$47'
  }, {
    name: 'Técnica de emergencia para noches difíciles',
    value: 'Incluido'
  }, {
    name: 'Checklist de detonantes nocturnos',
    value: 'Incluido'
  }, {
    name: 'Mini guía para dejar de medir el zumbido',
    value: 'Incluido'
  }, {
    name: 'Acceso inmediato desde celular',
    value: 'Incluido'
  }, {
    name: 'Actualizaciones futuras incluidas',
    value: 'Incluido'
  }];
  const bonuses: StackItem[] = [{
    name: 'Bono #1 — Kit de Rescate Nocturno Anti-Zumbido',
    value: '$67'
  }, {
    name: 'Bono #2 — Checklist Pre-Sueño de 7 Minutos',
    value: '$47'
  }, {
    name: 'Bono #3 — Guía "Menos Lucha, Más Silencio"',
    value: '$47'
  }, {
    name: 'Bono #4 — Tracker de Noches en Calma',
    value: '$39'
  }];
  return <section className="py-16 md:py-20 px-5 md:px-8 relative" data-id="element-293">
      <div className="max-w-3xl mx-auto" data-id="element-294">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-[#0B1224] to-[#070B16] border-2 border-[#F6C65B]/40 rounded-3xl p-6 md:p-10 shadow-[0_0_50px_rgba(246,198,91,0.15)]" data-id="element-295">
          {/* Header */}
          <div className="text-center mb-10" data-id="element-296">
            <div className="inline-flex items-center gap-2 bg-[#F6C65B]/15 border border-[#F6C65B]/40 rounded-full px-4 py-1.5 mb-4" data-id="element-297">
              <GiftIcon className="w-4 h-4 text-[#F6C65B]" data-id="element-298" />
              <span className="text-[#F6C65B] text-xs md:text-sm font-bold tracking-widest uppercase" data-id="element-299">
                Recapitulación de tu orden
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-300">
              Todo lo que te llevas{' '}
              <span className="text-[#F6C65B]" data-id="element-301">solo en esta página</span>
            </h2>
          </div>

          {/* Producto principal */}
          <div className="mb-8" data-id="element-302">
            <div className="flex items-center gap-2 mb-4" data-id="element-303">
              <SparklesIcon className="w-4 h-4 text-[#F6C65B]" data-id="element-304" />
              <span className="text-[#F6C65B] text-xs md:text-sm font-bold tracking-wider uppercase" data-id="element-305">
                Producto Principal
              </span>
            </div>
            <div className="space-y-2.5" data-id="element-306">
              {mainProductItems.map((item, i) => <div key={i} className="flex items-center justify-between gap-4 bg-[#070B16]/60 border border-[#F6C65B]/15 rounded-xl px-4 py-3 md:px-5 md:py-3.5" data-id="element-307">
                  <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-308">
                    <CheckIcon className="w-5 h-5 text-[#F6C65B] flex-shrink-0" data-id="element-309" />
                    <span className="text-gray-100 text-sm md:text-base" data-id="element-310">
                      {item.name}
                    </span>
                  </div>
                  <span className={`text-sm md:text-base flex-shrink-0 ${item.value === 'Incluido' ? 'text-gray-400' : 'text-gray-500 line-through font-semibold'}`} data-id="element-311">
                    {item.value}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Bonos */}
          <div className="mb-8" data-id="element-312">
            <div className="flex items-center gap-2 mb-4" data-id="element-313">
              <GiftIcon className="w-4 h-4 text-[#F6C65B]" data-id="element-314" />
              <span className="text-[#F6C65B] text-xs md:text-sm font-bold tracking-wider uppercase" data-id="element-315">
                Bonos Exclusivos · Solo Hoy
              </span>
            </div>
            <div className="space-y-2.5" data-id="element-316">
              {bonuses.map((item, i) => <div key={i} className="flex items-center justify-between gap-4 bg-[#070B16]/60 border border-[#F6C65B]/15 rounded-xl px-4 py-3 md:px-5 md:py-3.5" data-id="element-317">
                  <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-318">
                    <GiftIcon className="w-5 h-5 text-[#F6C65B] flex-shrink-0" data-id="element-319" />
                    <span className="text-gray-100 text-sm md:text-base" data-id="element-320">
                      {item.name}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0" data-id="element-321">
                    <span className="text-gray-500 line-through text-sm md:text-base font-semibold" data-id="element-322">
                      {item.value}
                    </span>
                    <span className="bg-green-500/20 text-green-400 border border-green-500/30 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-323">
                      GRATIS
                    </span>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Cálculo final */}
          <div className="border-t border-[#F6C65B]/30 pt-6 space-y-3" data-id="element-324">
            <div className="flex justify-between items-center" data-id="element-325">
              <span className="text-gray-300 text-base md:text-lg" data-id="element-326">
                Valor total real:
              </span>
              <span className="text-gray-400 line-through text-xl md:text-2xl font-semibold" data-id="element-327">
                $247 USD
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-328">
              <span className="text-gray-300 text-base md:text-lg" data-id="element-329">
                Tu inversión hoy:
              </span>
              <span className="text-[#F6C65B] font-bold text-3xl md:text-4xl" data-id="element-330">
                $11.99 USD
              </span>
            </div>
            <div className="flex justify-between items-center pt-3 border-t border-[#F6C65B]/20" data-id="element-331">
              <span className="text-white font-bold text-base md:text-lg" data-id="element-332">
                🔥 Ahorro total:
              </span>
              <span className="bg-green-500/20 text-green-400 border border-green-500/30 font-bold text-lg md:text-xl px-4 py-1.5 rounded-full" data-id="element-333">
                $235.01 USD
              </span>
            </div>
          </div>

          <p className="text-center text-gray-200 text-base md:text-lg mt-8 leading-relaxed" data-id="element-334">
            Solo en esta página, te llevas el{' '}
            <span className="text-white font-semibold" data-id="element-335">
              Protocolo Silencio TTPM™
            </span>{' '}
            MÁS estos{' '}
            <span className="text-[#F6C65B] font-bold" data-id="element-336">
              4 Regalos (valorados en $200)
            </span>{' '}
            totalmente <span className="text-[#F6C65B] font-bold" data-id="element-337">GRATIS</span>.
          </p>
        </motion.div>
      </div>
    </section>;
}